// Create React App only exposes env vars prefixed with REACT_APP_ to the
// browser — a bare SERVER_URL would always be undefined here.
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_SERVER_URL ||
  "http://localhost:8081";

const SERVER_URL = `${API_BASE_URL.replace(/\/$/, "")}/admin/`;

// Base URL for files stored in the GCS bucket (contact-form attachments).
// Attachment URLs from the API are already absolute, so this is only a helper
// for building paths if ever needed.
const GCP_BUCKET_URL =
  "https://storage.googleapis.com/cdn-roundtechsquare/wellcarePharmacy";

module.exports = {
  API_BASE_URL,
  SERVER_URL,
  GCP_BUCKET_URL,
};
